// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GXJC","right":"styles_right__Fyv3b"};